import './button-link.scss'
import type { FC } from 'react'
import { cx } from '@/common/utils/className'

interface ButtonLinkProps {
    onClick?: () => void
    className?: string
    label?: string
}

const ButtonLink: FC<ButtonLinkProps> = props => {
    const { onClick, className, label } = props
    const classNames = cx('btn-link', className)
    if (!label) return null
    return (
        <button onClick={onClick} className={classNames}>
            {label}
        </button>
    )
}

export default ButtonLink
